import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _SIX_FOOD_CATEGORY_LI, _MEALS, _MEAL_LIGHTS, _MACROS_3_NUTRITION_U, _SIX_FOOD_CATEGORY$mi, _SIX_FOOD_CATEGORY$mi2, _SIX_FOOD_CATEGORY$mi3, _SIX_FOOD_CATEGORY$me, _SIX_FOOD_CATEGORY$me2, _SIX_FOOD_CATEGORY$me3, _SIX_FOOD_CATEGORY$me4, _SIX_FOOD_CATEGORY$gr, _SIX_FOOD_CATEGORY$ve, _SIX_FOOD_CATEGORY$fr, _SIX_FOOD_CATEGORY$oi, _SIX_CATEGORY_TO_MACR, _FoodNoteItem3Nutriti, _FoodNoteItemCalorieQ, _FoodNoteItemCalorieO, _TargetTypeMap;

import * as R from 'ramda';
import { FoodLightType, FoodNoteItem3NutritionQuickAddKind, FoodNoteItemCalorieQuickAddKind, FoodNoteItemQuickAddType, MEAL_ORDER, NUTRITION_KEY, SIX_FOOD_CATEGORY, THREE_NUTRITION, THREE_NUTRITION_PERCENTAGE_KEY, TargetType } from 'src/types/diet';
export var DEFAULT_EE_VALUE = 1500;
export var CALORIE_PER_KG = 7700;
export var nutritionTableLine = [{
  header: 'client_mgmt:sixGroup.meat',
  columns: [{
    accessorKey: 'meat_beans_low_fat',
    text: '低脂',
    header: 'client_mgmt:sixGroup.meat_beans_low_fat_brief'
  }, {
    accessorKey: 'meat_beans_medium_fat',
    text: '中脂',
    header: 'client_mgmt:sixGroup.meat_beans_medium_fat_brief'
  }, {
    accessorKey: 'meat_beans_high_fat',
    text: '高脂',
    header: 'client_mgmt:sixGroup.meat_beans_high_fat_brief'
  }, {
    accessorKey: 'meat_beans_super_high_fat',
    text: '超高',
    header: 'client_mgmt:sixGroup.meat_beans_super_high_fat_brief'
  }]
}, {
  header: 'client_mgmt:sixGroup.vegetables',
  text: '蔬菜',
  columns: [{
    accessorKey: 'vegetables'
  }]
}, {
  header: 'client_mgmt:sixGroup.grains',
  text: '全穀雜糧',
  columns: [{
    accessorKey: 'grains'
  }]
}, {
  header: 'client_mgmt:sixGroup.oil',
  text: '油脂',
  columns: [{
    accessorKey: 'oil'
  }]
}, {
  header: 'client_mgmt:sixGroup.milk',
  text: '乳品',
  columns: [{
    accessorKey: 'milk_skim',
    header: 'client_mgmt:sixGroup.milk_skim_brief',
    text: '脫脂'
  }, {
    accessorKey: 'milk_low_fat',
    header: 'client_mgmt:sixGroup.milk_low_fat_brief',
    text: '低脂'
  }, {
    accessorKey: 'milk_whole_fat',
    header: 'client_mgmt:sixGroup.milk_whole_fat_brief',
    text: '全脂'
  }]
}, {
  header: 'client_mgmt:sixGroup.fruits',
  text: '水果',
  columns: [{
    accessorKey: 'fruits'
  }]
}];
export var otherNutrition = [[{
  key: 'fatty_acids_total_polyunsaturated',
  unit: 'mg'
}, {
  key: 'fatty_acids_total_monounsaturated',
  unit: 'mg'
}, {
  key: 'fatty_acids_total_saturated',
  unit: 'mg'
}, {
  key: 'asp',
  unit: 'mg'
}], [{
  key: 'linoleic_acid',
  unit: 'mg'
}, {
  key: 'myristoleic_acid',
  unit: 'mg'
}, {
  key: 'butyric_acid',
  unit: 'mg'
}, {
  key: 'thr',
  unit: 'mg'
}], [{
  key: 'linolenic_acid',
  unit: 'mg'
}, {
  key: 'palmitoleic_acid',
  unit: 'mg'
}, {
  key: 'caprylic_acid',
  unit: 'mg'
}, {
  key: 'ser',
  unit: 'mg'
}], [{
  key: 'octadecatetraenoicacid',
  unit: 'mg'
}, {
  key: 'oleic_acid',
  unit: 'mg'
}, {
  key: 'capric_acid',
  unit: 'mg'
}, {
  key: 'ser',
  unit: 'mg'
}], [{
  key: 'arachidonic_acid',
  unit: 'mg'
}, {
  key: 'gadoleic_acid',
  unit: 'mg'
}, {
  key: 'lauric_acid',
  unit: 'mg'
}, {
  key: 'pro',
  unit: 'mg'
}], [{
  key: 'eicosapentaenoic_acid_epa',
  unit: 'mg'
}, {
  key: 'erucic_acid',
  unit: 'mg'
}, {
  key: 'tridecanoic_acid',
  unit: 'mg'
}, {
  key: 'gly',
  unit: 'mg'
}], [{
  key: 'docosapentaenoic_acid',
  unit: 'mg'
}, null, {
  key: 'myristic_acid',
  unit: 'mg'
}, {
  key: 'ala',
  unit: 'mg'
}], [{
  key: 'docosahexaenoic_acid_dha',
  unit: 'mg'
}, null, {
  key: 'pentadecanoic_acid',
  unit: 'mg'
}, {
  key: 'cys',
  unit: 'mg'
}], [null, null, {
  key: 'palmitic_acid',
  unit: 'mg'
}, {
  key: 'val',
  unit: 'mg'
}], [null, null, {
  key: 'margaric_acid',
  unit: 'mg'
}, {
  key: 'met',
  unit: 'mg'
}], [null, null, {
  key: 'stearic_acid',
  unit: 'mg'
}, {
  key: 'ile',
  unit: 'mg'
}], [null, null, {
  key: 'nonadecanoic_acid',
  unit: 'mg'
}, {
  key: 'leu',
  unit: 'mg'
}], [null, null, {
  key: 'arachidic_acid',
  unit: 'mg'
}, {
  key: 'tyr',
  unit: 'mg'
}], [null, null, {
  key: 'behenic_acid',
  unit: 'mg'
}, {
  key: 'phe',
  unit: 'mg'
}], [null, null, {
  key: 'lignoceric_acid',
  unit: 'mg'
}, {
  key: 'lys',
  unit: 'mg'
}], [null, null, null, {
  key: 'his',
  unit: 'mg'
}], [null, null, null, {
  key: 'arg',
  unit: 'mg'
}], [null, null, null, {
  key: 'trp',
  unit: 'mg'
}]];
export var mainNutrition = [{
  key: 'calorie',
  unit: 'kcal'
}, {
  key: 'protein',
  unit: 'g'
}, {
  key: 'fat',
  unit: 'g'
}, {
  key: 'carbohydrate',
  unit: 'g'
}, {
  key: 'fiber',
  unit: 'g'
}, {
  key: 'dietary_fiber',
  unit: 'g'
}, {
  key: 'total_sugars',
  unit: 'g'
}, {
  key: 'cholesterol',
  unit: 'mg'
}, {
  key: 'water',
  unit: 'g'
}];
export var vitamins = [[{
  key: 'retinol_equivalentre',
  unit: 'μg RE'
}, {
  key: 'vitD',
  unit: 'μg'
}, {
  key: 'vite',
  unit: 'mg α-TE	'
}, {
  key: 'vitK',
  unit: 'μg'
}, {
  key: 'b1',
  unit: 'mg'
}, {
  key: 'b2',
  unit: 'mg'
}, {
  key: 'niacin',
  unit: 'mg NE'
}], [{
  key: 'pantothenic_acid',
  unit: 'mg'
}, {
  key: 'b6',
  unit: 'mg'
}, {
  key: 'biotin',
  unit: 'μg'
}, {
  key: 'folicacid',
  unit: 'μg'
}, {
  key: 'b12',
  unit: 'μg'
}, {
  key: 'choline',
  unit: 'mg'
}, {
  key: 'vitc',
  unit: 'mg'
}]];
export var minerals = [{
  key: 'na',
  unit: 'mg'
}, {
  key: 'k',
  unit: 'mg'
}, {
  key: 'ca',
  unit: 'mg'
}, {
  key: 'mg',
  unit: 'mg'
}, {
  key: 'p',
  unit: 'mg'
}, {
  key: 'fe',
  unit: 'mg'
}, {
  key: 'zn',
  unit: 'μg'
}, {
  key: 'i',
  unit: 'μg'
}, {
  key: 'se',
  unit: 'μg'
}, {
  key: 'f',
  unit: 'mg'
}];
export var SIX_FOOD_CATEGORY_LIMIT = (_SIX_FOOD_CATEGORY_LI = {}, _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.fruits, 1.5), _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.milk, 1.5), _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.oil, 1.2), _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.meat, 1.2), _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.grains, 1.2), _defineProperty(_SIX_FOOD_CATEGORY_LI, SIX_FOOD_CATEGORY.vegetables, Infinity), _SIX_FOOD_CATEGORY_LI);
export var MEALS = (_MEALS = {}, _defineProperty(_MEALS, MEAL_ORDER.BREAKFAST, {
  i18n: 'client_mgmt:meal.breakfast',
  meal_order_id: MEAL_ORDER.BREAKFAST,
  text: '早餐',
  descI18nKey: 'client_mgmt:mealDesc.breakfast'
}), _defineProperty(_MEALS, MEAL_ORDER.MORNING_SNACK, {
  i18n: 'client_mgmt:meal.morning_snack',
  meal_order_id: MEAL_ORDER.MORNING_SNACK,
  text: '早點',
  descI18nKey: 'client_mgmt:mealDesc.morning_snack'
}), _defineProperty(_MEALS, MEAL_ORDER.LUNCH, {
  i18n: 'client_mgmt:meal.lunch',
  meal_order_id: MEAL_ORDER.LUNCH,
  text: '午餐',
  descI18nKey: 'client_mgmt:mealDesc.lunch'
}), _defineProperty(_MEALS, MEAL_ORDER.AFTERNOON_SNACK, {
  i18n: 'client_mgmt:meal.afternoon_snack',
  meal_order_id: MEAL_ORDER.AFTERNOON_SNACK,
  text: '午點',
  descI18nKey: 'client_mgmt:mealDesc.afternoon_snack'
}), _defineProperty(_MEALS, MEAL_ORDER.DINNER, {
  i18n: 'client_mgmt:meal.dinner',
  meal_order_id: MEAL_ORDER.DINNER,
  text: '晚餐',
  descI18nKey: 'client_mgmt:mealDesc.dinner'
}), _defineProperty(_MEALS, MEAL_ORDER.EVENING_SNACK, {
  i18n: 'client_mgmt:meal.evening_snack',
  meal_order_id: MEAL_ORDER.EVENING_SNACK,
  text: '晚點',
  descI18nKey: 'client_mgmt:mealDesc.evening_snack'
}), _defineProperty(_MEALS, MEAL_ORDER.SNACK, {
  i18n: 'client_mgmt:meal.snack',
  meal_order_id: MEAL_ORDER.SNACK,
  text: '點心',
  descI18nKey: 'client_mgmt:mealDesc.snack'
}), _MEALS);
export var MEAL_LIGHTS = (_MEAL_LIGHTS = {}, _defineProperty(_MEAL_LIGHTS, FoodLightType.green, 'green.400'), _defineProperty(_MEAL_LIGHTS, FoodLightType.red, 'red.400'), _defineProperty(_MEAL_LIGHTS, FoodLightType.yellow, 'yellow.400'), _defineProperty(_MEAL_LIGHTS, "gray", 'gray.200'), _MEAL_LIGHTS);
export var NutritionConstant = {
  C63: [NUTRITION_KEY.calorie, SIX_FOOD_CATEGORY.fruits, SIX_FOOD_CATEGORY.vegetables, SIX_FOOD_CATEGORY.grains, SIX_FOOD_CATEGORY.meat_beans_low_fat, SIX_FOOD_CATEGORY.meat_beans_medium_fat, SIX_FOOD_CATEGORY.meat_beans_high_fat, SIX_FOOD_CATEGORY.meat_beans_super_high_fat, SIX_FOOD_CATEGORY.milk_skim, SIX_FOOD_CATEGORY.milk_low_fat, SIX_FOOD_CATEGORY.milk_whole_fat, SIX_FOOD_CATEGORY.oil, THREE_NUTRITION.carbohydrate, THREE_NUTRITION.protein, THREE_NUTRITION.fat, NUTRITION_KEY.refined_sugar, 'water_intake', 'added_at'],
  SIXGROUPS: [SIX_FOOD_CATEGORY.fruits, SIX_FOOD_CATEGORY.vegetables, SIX_FOOD_CATEGORY.grains, SIX_FOOD_CATEGORY.meat_beans_low_fat, SIX_FOOD_CATEGORY.meat_beans_medium_fat, SIX_FOOD_CATEGORY.meat_beans_high_fat, SIX_FOOD_CATEGORY.meat_beans_super_high_fat, SIX_FOOD_CATEGORY.milk_skim, SIX_FOOD_CATEGORY.milk_low_fat, SIX_FOOD_CATEGORY.milk_whole_fat, SIX_FOOD_CATEGORY.oil],
  MACROS_3_NUTRITION: [THREE_NUTRITION.carbohydrate, THREE_NUTRITION.protein, THREE_NUTRITION.fat],
  MACROS_3_NUTRITION_UNIT_CAL: (_MACROS_3_NUTRITION_U = {}, _defineProperty(_MACROS_3_NUTRITION_U, THREE_NUTRITION.carbohydrate, 4), _defineProperty(_MACROS_3_NUTRITION_U, THREE_NUTRITION.protein, 4), _defineProperty(_MACROS_3_NUTRITION_U, THREE_NUTRITION.fat, 9), _MACROS_3_NUTRITION_U),
  MACROS_3_NUTRITION_PERCENTAGE_KEYS: [THREE_NUTRITION_PERCENTAGE_KEY.protein, THREE_NUTRITION_PERCENTAGE_KEY.fat, THREE_NUTRITION_PERCENTAGE_KEY.carbohydrate],
  SIX_FOOD_CATEGORIES: [{
    key: SIX_FOOD_CATEGORY.meat,
    subCategoryKeys: [SIX_FOOD_CATEGORY.meat_beans_high_fat, SIX_FOOD_CATEGORY.meat_beans_low_fat, SIX_FOOD_CATEGORY.meat_beans_medium_fat, SIX_FOOD_CATEGORY.meat_beans_super_high_fat]
  }, {
    key: SIX_FOOD_CATEGORY.vegetables
  }, {
    key: SIX_FOOD_CATEGORY.grains
  }, {
    key: SIX_FOOD_CATEGORY.oil
  }, {
    key: SIX_FOOD_CATEGORY.milk,
    subCategoryKeys: [SIX_FOOD_CATEGORY.milk_low_fat, SIX_FOOD_CATEGORY.milk_skim, SIX_FOOD_CATEGORY.milk_whole_fat]
  }, {
    key: SIX_FOOD_CATEGORY.fruits
  }],
  SIX_CATEGORY_TO_MACROS: (_SIX_CATEGORY_TO_MACR = {}, _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.milk_whole_fat, (_SIX_FOOD_CATEGORY$mi = {}, _defineProperty(_SIX_FOOD_CATEGORY$mi, THREE_NUTRITION.protein, 8), _defineProperty(_SIX_FOOD_CATEGORY$mi, THREE_NUTRITION.carbohydrate, 12), _defineProperty(_SIX_FOOD_CATEGORY$mi, THREE_NUTRITION.fat, 8), _SIX_FOOD_CATEGORY$mi)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.milk_low_fat, (_SIX_FOOD_CATEGORY$mi2 = {}, _defineProperty(_SIX_FOOD_CATEGORY$mi2, THREE_NUTRITION.protein, 8), _defineProperty(_SIX_FOOD_CATEGORY$mi2, THREE_NUTRITION.carbohydrate, 12), _defineProperty(_SIX_FOOD_CATEGORY$mi2, THREE_NUTRITION.fat, 4), _SIX_FOOD_CATEGORY$mi2)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.milk_skim, (_SIX_FOOD_CATEGORY$mi3 = {}, _defineProperty(_SIX_FOOD_CATEGORY$mi3, THREE_NUTRITION.protein, 8), _defineProperty(_SIX_FOOD_CATEGORY$mi3, THREE_NUTRITION.carbohydrate, 12), _defineProperty(_SIX_FOOD_CATEGORY$mi3, THREE_NUTRITION.fat, 0), _SIX_FOOD_CATEGORY$mi3)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.meat_beans_low_fat, (_SIX_FOOD_CATEGORY$me = {}, _defineProperty(_SIX_FOOD_CATEGORY$me, THREE_NUTRITION.protein, 7), _defineProperty(_SIX_FOOD_CATEGORY$me, THREE_NUTRITION.carbohydrate, 0), _defineProperty(_SIX_FOOD_CATEGORY$me, THREE_NUTRITION.fat, 3), _SIX_FOOD_CATEGORY$me)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.meat_beans_medium_fat, (_SIX_FOOD_CATEGORY$me2 = {}, _defineProperty(_SIX_FOOD_CATEGORY$me2, THREE_NUTRITION.protein, 7), _defineProperty(_SIX_FOOD_CATEGORY$me2, THREE_NUTRITION.carbohydrate, 0), _defineProperty(_SIX_FOOD_CATEGORY$me2, THREE_NUTRITION.fat, 5), _SIX_FOOD_CATEGORY$me2)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.meat_beans_high_fat, (_SIX_FOOD_CATEGORY$me3 = {}, _defineProperty(_SIX_FOOD_CATEGORY$me3, THREE_NUTRITION.protein, 7), _defineProperty(_SIX_FOOD_CATEGORY$me3, THREE_NUTRITION.carbohydrate, 0), _defineProperty(_SIX_FOOD_CATEGORY$me3, THREE_NUTRITION.fat, 10), _SIX_FOOD_CATEGORY$me3)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.meat_beans_super_high_fat, (_SIX_FOOD_CATEGORY$me4 = {}, _defineProperty(_SIX_FOOD_CATEGORY$me4, THREE_NUTRITION.protein, 7), _defineProperty(_SIX_FOOD_CATEGORY$me4, THREE_NUTRITION.carbohydrate, 0), _defineProperty(_SIX_FOOD_CATEGORY$me4, THREE_NUTRITION.fat, 14), _SIX_FOOD_CATEGORY$me4)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.grains, (_SIX_FOOD_CATEGORY$gr = {}, _defineProperty(_SIX_FOOD_CATEGORY$gr, THREE_NUTRITION.protein, 2), _defineProperty(_SIX_FOOD_CATEGORY$gr, THREE_NUTRITION.carbohydrate, 15), _defineProperty(_SIX_FOOD_CATEGORY$gr, THREE_NUTRITION.fat, 0), _SIX_FOOD_CATEGORY$gr)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.vegetables, (_SIX_FOOD_CATEGORY$ve = {}, _defineProperty(_SIX_FOOD_CATEGORY$ve, THREE_NUTRITION.protein, 1), _defineProperty(_SIX_FOOD_CATEGORY$ve, THREE_NUTRITION.carbohydrate, 5), _defineProperty(_SIX_FOOD_CATEGORY$ve, THREE_NUTRITION.fat, 0), _SIX_FOOD_CATEGORY$ve)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.fruits, (_SIX_FOOD_CATEGORY$fr = {}, _defineProperty(_SIX_FOOD_CATEGORY$fr, THREE_NUTRITION.protein, 0), _defineProperty(_SIX_FOOD_CATEGORY$fr, THREE_NUTRITION.carbohydrate, 15), _defineProperty(_SIX_FOOD_CATEGORY$fr, THREE_NUTRITION.fat, 0), _SIX_FOOD_CATEGORY$fr)), _defineProperty(_SIX_CATEGORY_TO_MACR, SIX_FOOD_CATEGORY.oil, (_SIX_FOOD_CATEGORY$oi = {}, _defineProperty(_SIX_FOOD_CATEGORY$oi, THREE_NUTRITION.protein, 0), _defineProperty(_SIX_FOOD_CATEGORY$oi, THREE_NUTRITION.carbohydrate, 0), _defineProperty(_SIX_FOOD_CATEGORY$oi, THREE_NUTRITION.fat, 5), _SIX_FOOD_CATEGORY$oi)), _SIX_CATEGORY_TO_MACR)
};
export var FoodNoteItem3NutritionQuickAddKindAttr = (_FoodNoteItem3Nutriti = {}, _defineProperty(_FoodNoteItem3Nutriti, FoodNoteItem3NutritionQuickAddKind.refined_sugar, {
  unitKey: 'common:unit.gram',
  item_name: '精緻糖',
  i18n: 'client_mgmt:normal.refined_sugar',
  calorie: NutritionConstant.MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.carbohydrate],
  key: FoodNoteItem3NutritionQuickAddKind.refined_sugar
}), _defineProperty(_FoodNoteItem3Nutriti, FoodNoteItem3NutritionQuickAddKind.sugar, {
  unitKey: 'common:unit.gram',
  item_name: '糖',
  i18n: 'client_mgmt:threeCategory.carbohydrate',
  calorie: NutritionConstant.MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.carbohydrate],
  key: FoodNoteItem3NutritionQuickAddKind.sugar
}), _defineProperty(_FoodNoteItem3Nutriti, FoodNoteItem3NutritionQuickAddKind.protein, {
  unitKey: 'common:unit.gram',
  item_name: '蛋白質',
  i18n: 'client_mgmt:threeCategory.protein',
  calorie: NutritionConstant.MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.protein],
  key: FoodNoteItem3NutritionQuickAddKind.protein
}), _defineProperty(_FoodNoteItem3Nutriti, FoodNoteItem3NutritionQuickAddKind.fat, {
  unitKey: 'common:unit.gram',
  item_name: '脂質',
  i18n: 'client_mgmt:threeCategory.fat',
  calorie: NutritionConstant.MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.fat],
  key: FoodNoteItem3NutritionQuickAddKind.fat
}), _FoodNoteItem3Nutriti);
export var FoodNoteItemCalorieQuickAddKindAttr = (_FoodNoteItemCalorieQ = {}, _defineProperty(_FoodNoteItemCalorieQ, FoodNoteItemCalorieQuickAddKind.sugar, FoodNoteItem3NutritionQuickAddKindAttr[FoodNoteItemCalorieQuickAddKind.sugar]), _defineProperty(_FoodNoteItemCalorieQ, FoodNoteItemCalorieQuickAddKind.protein, FoodNoteItem3NutritionQuickAddKindAttr[FoodNoteItemCalorieQuickAddKind.protein]), _defineProperty(_FoodNoteItemCalorieQ, FoodNoteItemCalorieQuickAddKind.fat, FoodNoteItem3NutritionQuickAddKindAttr[FoodNoteItemCalorieQuickAddKind.fat]), _defineProperty(_FoodNoteItemCalorieQ, FoodNoteItemCalorieQuickAddKind.custom, {
  key: FoodNoteItemCalorieQuickAddKind.custom
}), _defineProperty(_FoodNoteItemCalorieQ, FoodNoteItemCalorieQuickAddKind.alcohol, {
  unitKey: 'common:unit.gram',
  item_name: '酒精',
  i18n: 'client_mgmt:normal.alcohol',
  calorie: 7,
  key: FoodNoteItemCalorieQuickAddKind.alcohol
}), _FoodNoteItemCalorieQ);
export var FoodNoteItemCalorieOr3NutritionQuickAddKindAttr = (_FoodNoteItemCalorieO = {}, _defineProperty(_FoodNoteItemCalorieO, FoodNoteItemQuickAddType.calorie, FoodNoteItemCalorieQuickAddKindAttr), _defineProperty(_FoodNoteItemCalorieO, FoodNoteItemQuickAddType.macros, FoodNoteItem3NutritionQuickAddKindAttr), _FoodNoteItemCalorieO);
export var MACROS_6_FOOD_CATEGORIES_WITH_SUBCATEGORIES = R.chain(function (category) {
  return R.propOr(category.key ? [category.key] : [], 'subCategoryKeys', category);
})(NutritionConstant.SIX_FOOD_CATEGORIES);
export var TargetTypeMap = (_TargetTypeMap = {}, _defineProperty(_TargetTypeMap, TargetType.LOSE_WEIGHT, {
  id: TargetType.LOSE_WEIGHT,
  i18nKey: 'client_mgmt:normal.loseWeight',
  text: '減重'
}), _defineProperty(_TargetTypeMap, TargetType.GAIN_WEIGHT, {
  id: TargetType.GAIN_WEIGHT,
  i18nKey: 'client_mgmt:normal.gainWeight',
  text: '增重'
}), _defineProperty(_TargetTypeMap, TargetType.MAINTAIN_WEIGHT, {
  id: TargetType.MAINTAIN_WEIGHT,
  i18nKey: 'client_mgmt:normal.maintainWeight',
  text: '維持體重'
}), _TargetTypeMap);